import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  inputRow: {
    margin: theme.spacing(1, 0),
    height: 40,
  },
  title: {
    margin: theme.spacing(3, 0),
  },
  calendarWrapper: {
    margin: theme.spacing(1, 0),
  },
  tableFormWrapper: {
    marginBottom: theme.spacing(4),
    overflow: 'hidden',
  },
  tableWrapper: {
    marginBottom: theme.spacing(4),
  },
  buttonSection: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
}));

export default useStyles;
